import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import {
  AdvisoryAgainstData,
  advisoryAgainstSchema,
} from "../AdvisoryAgainstForm.schema";

export function useAdvisoryAgainstForm() {
  return useForm<AdvisoryAgainstData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(advisoryAgainstSchema) as any,
    defaultValues: {
      docRejectReason1: false,
      docRejectReason2: false,
      docRejectDet: "",
    },
  });
}
